import React from 'react'

import SelectComparablePropertySkeleton from '@components/compare-property/v2/skeleton'

import { ComparableProperty, PropertyType } from '@adUtilities/types'

import ComparableLotItem from './comparable-lot-item'
import ComparableUnitItem from './comparable-unit-item'

interface ComparablePropertyItemProps {
  comparableProperty: ComparableProperty
  fullScreenMode?: boolean
}

function ComparablePropertyItem({
  comparableProperty,
  fullScreenMode,
}: ComparablePropertyItemProps) {
  if (!comparableProperty.property) {
    return <SelectComparablePropertySkeleton />
  }

  if (comparableProperty.property.propertyType === PropertyType.Unit) {
    return (
      <ComparableUnitItem
        unit={comparableProperty.property.data}
        fullScreenMode={fullScreenMode}
      />
    )
  }

  if (comparableProperty.property.propertyType === PropertyType.Lot) {
    return (
      <ComparableLotItem
        comparableLot={comparableProperty.property}
        fullScreenMode={fullScreenMode}
      />
    )
  }

  return null
}

export default ComparablePropertyItem
